import { createContext } from 'react';

const OfferReviewBulkContext = createContext(null);

export default OfferReviewBulkContext;
